import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class SlaExceedDetailReportService extends Service{
    constructor() {
        super();
        this.baseURL = 'slaExceedDetailReport';
    }

    findSlaByDate(interval) {
        return fetch(SERVER_URL + this.baseURL + '/' + interval, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findSlaByStartDateAndEndDate(dateStart,dateEnd) {
        return fetch(SERVER_URL + this.baseURL + '/findSlaByStartDateAndEndDate/'+dateStart+'/'+dateEnd, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}